var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9B",
    fillRule: "nonzero",
    d: "M21.18 13.719c.047-.39.077-.797.077-1.219 0-.422-.03-.828-.092-1.219l2.607-2.062a.651.651 0 0 0 .155-.797l-2.47-4.328a.624.624 0 0 0-.755-.282l-3.07 1.25a9.012 9.012 0 0 0-2.083-1.218L15.086.53A.618.618 0 0 0 14.469 0H9.53a.603.603 0 0 0-.601.531l-.463 3.313a9.253 9.253 0 0 0-2.083 1.219l-3.07-1.25a.607.607 0 0 0-.757.28L.09 8.423a.61.61 0 0 0 .154.797l2.608 2.062a7.95 7.95 0 0 0-.108 1.219c0 .406.03.828.092 1.219L.228 15.78a.651.651 0 0 0-.155.797l2.47 4.328a.624.624 0 0 0 .755.282l3.07-1.25c.648.5 1.327.906 2.083 1.218l.463 3.313c.062.312.309.531.617.531h4.938c.308 0 .57-.219.601-.531l.463-3.313a9.253 9.253 0 0 0 2.083-1.218l3.07 1.25c.278.109.602 0 .757-.282l2.468-4.328a.61.61 0 0 0-.154-.797L21.18 13.72zM12 17.188c-2.546 0-4.629-2.11-4.629-4.688S9.454 7.812 12 7.812c2.546 0 4.629 2.11 4.629 4.688S14.546 17.188 12 17.188z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settings.c0246787f8f0cbc84d7317540ffcadcb.svg";